module.exports = __webpack_public_path__ + "media/intro-portrait.40c5d54b.mp4";